import {
  Component,
  Inject,
  OnInit,
  Optional,
  inject,
  signal,
  effect,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { DataService } from "src/app/data.service";
import { db } from "src/app/db.service";
import "lodash";
import { StockService } from "src/app/stock/stock.service";
declare var _: any;
import { ColumnState, GridReadyEvent } from "ag-grid-community";

@Component({
  selector: "app-material-dialog",
  templateUrl: "./material-dialog.component.html",
  styleUrls: ["./material-dialog.component.css"],
})
export class NewMaterialDialogComponent implements OnInit {
  _stockService = inject(StockService);
  name: string;
  price: number;
  unit: string;
  showOperations: boolean = false;
  dataLoading: boolean = false;
  selectedStockGroupId;
  selectedStockGroupIdSig = signal(0);
  showProduction = signal(false);
  initialBalance: number = null;
  initialPrice: number = null;
  currentYear = new Date().getFullYear();

  agGridData$;
  columnDefs = [
    {
      headerName: "id",
      field: "tId",
      hide: true,
    },
    {
      headerName: "",
      field: "tType",
      flex: 1,
      minWidth: 100,
      cellRenderer: (params) => {
        switch (params.value) {
          case "Stock Entry":
            return '<span class="material-symbols-outlined">place_item</span>';
          case "Stock Out":
            return '<span class="material-symbols-outlined">move_item</span>';
          case "Stock Transfer":
            return '<span class="material-symbols-outlined">component_exchange</span>';
          case "Sells":
            return '<span  style="background-color: var(--primary-background), color: black" class="material-symbols-outlined">component_exchange</span>';
          case "Production":
            return '<span style="background-color: #0079ffeb" class="material-symbols-outlined">precision_manufacturing</span>';
          default:
            return '<span  style="background-color: var(--primary-background); color: white" class="material-symbols-outlined">sell</span>';
        }
      },
      cellClass: (params) => {
        switch (params.value) {
          case "Stock Entry":
            return "entryType stockEntry";
          case "Stock Out":
            return "entryType stockOut";
          case "Stock Transfer":
            return "entryType stockTransfer";
          default:
            return "entryType";
        }
      },
    },
    {
      headerName: "Miqdar",
      field: "quantity",
      flex: 3,
      minWidth: 100,
      cellRenderer: (params) =>
        params.value < 0 ? -params.value : params.value,
    },
    {
      headerName: "Qiymət",
      field: "price",
      flex: 3,
      minWidth: 100,
      cellRenderer: (params) =>
        params.value < 0 ? -params.value : params.value,
    },
    {
      headerName: "Tərəf-Müqabil",
      field: "customerId",
      flex: 3,
      minWidth: 100,
      cellRenderer: (params) =>
        params.value
          ? _.find(this._dataService.customers(), {
              id: params.value,
            }).name
          : "*",
      cellClass: (params) => {
        return "justify-content-start";
      },
    },
    {
      headerName: "Tarix",
      field: "date",
      flex: 3,
      minWidth: 100,
      sort: "desc",
    },
  ];
  gridApi: any;

  constructor(
    public dialogRef: MatDialogRef<NewMaterialDialogComponent>,
    private http: HttpClient,
    public _dataService: DataService,
    private toastr: ToastrService,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    effect(async () => {
      this.selectedStockGroupIdSig();
      this.showProduction();
      if (this.dialogData?.id)
        this.agGridData$ = await this._stockService.getMaterialOperations(
          this.dialogData?.id,
          this.selectedStockGroupIdSig(),
          this.showProduction()
        );
    });
  }

  ngOnInit(): void {
    if (this.dialogData) {
      this.name = this.dialogData.name;
      this.price = this.dialogData.price;
      this.unit = this.dialogData.unit;
      
      // Load initial stock balance for default stock group (if operations shown)
      if (this.showOperations) {
        this.loadInitialBalance();
      }
    }
  }
  
  async onStockGroupChange() {
    this.selectedStockGroupIdSig.set(this.selectedStockGroupId);
    await this.loadInitialBalance();
  }
  
  async loadInitialBalance() {
    if (!this.dialogData?.id || !this.selectedStockGroupId) {
      this.initialBalance = null;
      this.initialPrice = null;
      return;
    }
    
    try {
      const balance = await db.initialStockBalance
        .where('[materialId+stockGroupId]')
        .equals([this.dialogData.id, this.selectedStockGroupId])
        .first();
      
      if (balance) {
        this.initialBalance = balance.quantity;
        this.initialPrice = balance.price;
      } else {
        this.initialBalance = null;
        this.initialPrice = null;
      }
    } catch (error) {
      console.error('Error loading initial balance:', error);
    }
  }
  
  async saveInitialBalance(event: Event) {
    event.preventDefault();
    
    if (!this.dialogData?.id || !this.selectedStockGroupId) {
      this.toastr.error('Material və ya anbar seçilməyib');
      return;
    }
    
    if (this.initialBalance === null || this.initialBalance === undefined) {
      this.toastr.error('İlkin qalıq daxil edin');
      return;
    }
    
    try {
      const balanceData = {
        materialId: this.dialogData.id,
        stockGroupId: this.selectedStockGroupId,
        quantity: this.initialBalance,
        price: this.initialPrice || 0,
        year: this.currentYear
      };
      
      // Check if initial balance already exists
      const existing = await db.initialStockBalance
        .where('[materialId+stockGroupId]')
        .equals([this.dialogData.id, this.selectedStockGroupId])
        .first();
      
      if (existing) {
        // Update existing
        await db.initialStockBalance.update(existing.id, balanceData);
        
        // Also update on server
        await this.http.put(
          `${this._dataService.dbBase}api.php/records/initialStockBalance/${existing.id}`,
          balanceData
        ).toPromise();
        
        this.toastr.success('İlkin qalıq yeniləndi');
      } else {
        // Create new
        const localId = await db.initialStockBalance.add(balanceData);
        
        // Also create on server
        const serverId = await this.http.post(
          `${this._dataService.dbBase}api.php/records/initialStockBalance`,
          balanceData
        ).toPromise();
        
        // Update local record with server ID
        await db.initialStockBalance.update(localId, { id: serverId as number });
        
        this.toastr.success('İlkin qalıq saxlanıldı');
      }
      
      // CRITICAL: Trigger dashboard refresh to show updated anbar card
      // This makes the dashboard reload with the new initial balance
      this._dataService.dateChanged.next(new Date().toISOString());
      
    } catch (error) {
      console.error('Error saving initial balance:', error);
      this.toastr.error('Xəta baş verdi');
    }
  }

  addMaterial(formData, event) {
    event.srcElement.disabled = true;
    event.target.innerText = "Gözləyin ...";

    // CHECK IF DATA ALREADY EXISTS IN TABLE
    if (
      _.filter(this._dataService.materials(), (a) => {
        return a.name.toLowerCase() == formData.name.toLowerCase();
      }).length &&
      !this.dialogData
    ) {
      this.toastr.error("Bu adda məhsul mövcuddur");

      event.target.innerText = "Əlavə et";
      event.target.disabled = false;

      return;
    }

    let postMaterial;

    if (this.dialogData) {
      postMaterial = this.http.put(
        this._dataService.dbBase +
          "api.php/records/materials/" +
          this.dialogData.id,
        formData
      );
    } else {
      postMaterial = this.http.post(
        this._dataService.dbBase + "api.php/records/materials",
        formData
      );
    }

    return postMaterial.subscribe(
      (res) => {
        formData.id = this.dialogData?.id ? this.dialogData?.id : res;
        this.dialogRef.close(formData);

        if (this.dialogData?.id) {
          formData.id = this.dialogData.id;
          const index = this._dataService
            .materials()
            .findIndex((obj) => obj.id === this.dialogData.id);
          // TODO THIS WAS SIGNAL MUTATE I THINK ITS FIXED?
          this._dataService.materials()[index] = formData;
          this._dataService.materials.set([...this._dataService.materials()]);
          this.toastr.success("Material Yeniləndi");
        } else {
          formData.id = res;
          this._dataService.materials.set([
            ...this._dataService.materials(),
            formData,
          ]);
          this.toastr.success("Əlavə edildi!");
        }
        this.dialogRef.close(formData);
        this._dataService.setLS("materials", this._dataService.materials());
      },
      (err) => {
        console.log(err);
        event.srcElement.disabled = false;
        event.target.innerText = this.dialogData ? "Yenilə" : "Əlavə et";
        this.toastr.error("Xəta baş verdi, yenidən cəhd edin");
      }
    );
  }

  async materialOperations(event) {
    if (this.showOperations) {
      this.showOperations = false;
      return;
    }
    this.dataLoading = true;
    
    // Set default stock group if not set
    if (!this.selectedStockGroupId) {
      this.selectedStockGroupId = this._dataService.stockGroups()[0]?.id || 1;
      this.selectedStockGroupIdSig.set(this.selectedStockGroupId);
    }
    
    // Load initial balance for selected stock group
    await this.loadInitialBalance();
    
    this.agGridData$ = await this._stockService.getMaterialOperations(
      this.dialogData.id,
      this.selectedStockGroupIdSig(),
      this.showProduction()
    );
    this.dataLoading = false;
    this.showOperations = true;
  }

  transactionDetails(data) {
    this._stockService.openStockDialog(data);
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    // this.gridApi.setIncludeHiddenColumnsInQuickFilter(true);
    // this.gridApi.setGetRowClass((params) => {
    //   return params.node.data.justAdded == true ? "tableDataLoading" : "";
    // });
  }
}
